const defaultPerPage = 50

export function selectPerPage(store, key) {
    return store.settings.perPage[key] || defaultPerPage
}